"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoPointLocation = void 0;
const utils_1 = require("@daytrip/utils");
require("reflect-metadata");
/**
 * Mongo native format, must be also indexed as 2dsphere to work
 */
class MongoPointLocation {
    constructor(position) {
        this.type = "Point";
        if (position && !isNaN(position.longitude) && !isNaN(position.latitude)) {
            this.coordinates = (0, utils_1.convertLngLatToArray)(position);
        }
    }
    type = "Point";
    /**
     * [ longitude, latitude ]
     */
    coordinates;
}
exports.MongoPointLocation = MongoPointLocation;
//# sourceMappingURL=MongoPointLocation.js.map